import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: "https://7eed29a678c76e86768c35aaaa8012ed@o4504480337559552.ingest.us.sentry.io/4511546830159872",
    environment: import.meta.env.MODE,
    // Auto-recovered by the vite:preloadError handler below; drop the noise.
    // Wording differs per browser: Chrome/Firefox say "...dynamically imported
    // module", Safari/iOS says "Importing a module script failed".
    ignoreErrors: [
      /dynamically imported module/i,
      /Importing a module script failed/i,
      "ChunkLoadError",
      // Injected third-party code JSON.stringify-ing React-tagged DOM nodes
      // (the __reactFiber$ expando makes them circular). Not our bug to fix.
      /__reactFiber\$/,
    ],
  });
}

// Stale chunk after a deploy: reload to fetch fresh hashes.
// Debounce via sessionStorage to avoid a loop if a chunk is genuinely gone.
window.addEventListener("vite:preloadError", () => {
  const RELOAD_KEY = "vite:preloadError:lastReload";
  const RELOAD_DEBOUNCE_MS = 10000;
  const lastReload = Number(sessionStorage.getItem(RELOAD_KEY)) || 0;
  if (Date.now() - lastReload > RELOAD_DEBOUNCE_MS) {
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
    window.location.reload();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(<App />);
